import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const InformationWrapper: CSSObject = {
  pt: 4,
};

export const InputContainer: CSSObject = {
  '& .chakra-checkbox__label': {
    color: 'white',
    fontWeight: 'medium',
    fontSize: 'xs',
  },

  '& .chakra-form__label': {
    color: 'white',
    fontWeight: 'semibold',
    fontSize: 'xs',
  },

  '& .chakra-select': {
    h: '10',
    bg: 'white',
    color: 'black',
    fontSize: 'xs',
    borderRadius: 'md',
  },

  '& .chakra-checkbox': {
    color: 'white',
  },

  '& .chakra-checkbox__control': {
    boxSize: '18px',
    borderRadius: '2px',
    border: '1px',
    borderColor: 'gamma.400',
    bg: 'alpha.700',
  },
};

export const buttonConfirmBreakProps: CustomButtonProps = {
  height: '38px',
  variant: 'secondary',
};

export const TextConfirmBreak: CSSObject = {
  fontSize: 'xs',
  color: 'white',
};

export const TextDate: CSSObject = {
  fontSize: 'sm',
};

export const TextDateLabel: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'semibold',
};

export const BoxTakeABreak: CSSObject = {
  p: '0',
  m: '0',
  border: 'none',
};

export const buttonTakeBreakProps: CustomButtonProps = {
  variant: 'secondary',
  height: '38px',
};

export const ListItemExclusionItem: CSSObject = {
  fontSize: 'xs',
  color: 'white',
};

export const HeadingInformation: CSSObject = {
  fontWeight: 'medium',
  mb: '0',
  fontSize: 'sm',
  color: 'white',
};

export const TextInformation: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
  mb: '3',
  color: 'white',
  '&:first-of-type': {
    fontWeight: 'bold',
  },
};

export const BoxStyledLink: CSSObject = {
  color: 'white',
  textDecoration: 'underline',
};

export const TextM: CSSObject = {
  fontSize: 'sm',
  color: 'white',
  fontWeight: 'bold',
  mb: '0',
};

export const BoxTakeABreakWrapper: CSSObject = {
  pb: 0,
  border: 'none',
};

export const TakeABreakContainer: CSSObject = {
  color: 'white',
  p: '0',
  border: 'none',
  mb: '3',
};

export const TextS: CSSObject = {
  color: 'white',
  pt: '2',
  m: '0',
  fontSize: '12px',
  pb: '1',
  fontWeight: 'semibold',
};
